import { useState, useEffect, useCallback, useRef } from 'react';
import { EsporaiInput, EsporaiTextarea, OnboardingStepLayout } from 'components';

const OnboardingBusinessStep = ({ business_name, business_details, onChange, onValidation }) => {
  const [localName, setLocalName] = useState(business_name || '');
  const [localDetails, setLocalDetails] = useState(business_details || '');
  const [errorName, setErrorName] = useState(null);
  const [errorDetails, setErrorDetails] = useState(null);
  const [hasTypedName, setHasTypedName] = useState(Boolean(business_name));
  const [hasTypedDetails, setHasTypedDetails] = useState(Boolean(business_details));
  const [focusedName, setFocusedName] = useState(false);
  const [focusedDetails, setFocusedDetails] = useState(false);
  const validityRef = useRef();

  const validateName = useCallback(() => {
    if (!localName.trim()) {
      setErrorName('Este campo es requerido');
      return false;
    }
    if (localName.trim().length < 3) {
      setErrorName('Por favor, ingresa un mínimo de 3 caracteres');
      return false;
    }
    if (localName.trim().length > 25) {
      setErrorName('Por favor, ingresa un máximo de 25 caracteres.');
      return false;
    }
    setErrorName(null);
    return true;
  }, [localName]);

  const validateDetails = useCallback(() => {
    if (!localDetails.trim()) {
      setErrorDetails('Este campo es requerido');
      return false;
    }
    if (localDetails.trim().length < 10) {
      setErrorDetails('Contanos un poco más, mínimo 10 caracteres');
      return false;
    }
    setErrorDetails(null);
    return true;
  }, [localDetails]);

  // Validación y notificación solo si cambia validez
  useEffect(() => {
    const isNameValid = validateName();
    const isDetailsValid = validateDetails();
    const isValid = isNameValid && isDetailsValid;
    if (validityRef.current !== isValid) {
      onValidation(isValid);
      validityRef.current = isValid;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localName, localDetails]);

  const changeRef = useRef({});
  useEffect(() => {
    const payload = { business_name: localName, business_details: localDetails };
    const prev = changeRef.current;
    if (prev.business_name !== localName || prev.business_details !== localDetails) {
      onChange(payload);
      changeRef.current = payload;
    }
  }, [localName, localDetails, onChange]);

  return (
    <OnboardingStepLayout
      title="Contanos un poco más de tu negocio."
      subtitle="Brindanos el nombre y algunos detalles sobre tu negocio para que podamos armar una estrategia acorde."
    >
      <div className="space-y-4">
        <EsporaiInput
          value={localName}
          onChange={val => {
            setLocalName(val);
            if (!hasTypedName && val) setHasTypedName(true);
          }}
          placeholder="Nombre de tu negocio"
          onFocus={() => setFocusedName(true)}
          onBlur={() => setFocusedName(false)}
          error={focusedName && hasTypedName ? errorName : null}
        />
        <EsporaiTextarea
          value={localDetails}
          onChange={val => {
            setLocalDetails(val);
            if (!hasTypedDetails && val) setHasTypedDetails(true);
          }}
          placeholder="Detalles de tu negocio"
          onFocus={() => setFocusedDetails(true)}
          onBlur={() => setFocusedDetails(false)}
          error={focusedDetails && hasTypedDetails ? errorDetails : null}
          rows={5}
        />
      </div>
    </OnboardingStepLayout>
  );
};

export default OnboardingBusinessStep;
